import { steps } from 'constants/constants';
import { Button, Col, Row } from 'react-bootstrap';
import { ReactComponent as CheckIcon } from 'assets/images/check.svg';
import { ReactComponent as CancelIcon } from 'assets/images/cancel.svg';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { onSubmitParams } from './types';
import { useEffect, useState } from 'react';
import { useGetTeamByProjectIdMutation } from 'redux/services/teams';
import Modal from 'components/common/Modal/Modal';
import { useGetProjectsMutation } from 'redux/services/project';
import { saveProjects, setFetchProjectsInProgress } from 'redux/projectSlice';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

interface LaunchProps {
  onSubmitProject: (params: onSubmitParams) => void;
  projectDetails: any;
}

const Launch = ({ onSubmitProject, projectDetails }: LaunchProps) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const [fetchProjects] = useGetProjectsMutation();
  const { step, setupId: projectId } = useParams();
  const navigate = useNavigate();
  const [getTeamByProjectId, { data }] = useGetTeamByProjectIdMutation();
  const [loading, setLoading] = useState<boolean>(false);

  const handleClose = () => {
    setShow(false);
    navigate('/projects', { replace: true });
  };
  const handleShow = () => setShow(true);

  const saveProject = async () => {
    const params = {
      values: {},
      draft: false,
      redirectAfterSubmit: false,
    };
    setLoading(true);
    const allSetup: any = await onSubmitProject(params);
    if (allSetup) {
      handleShow();
    } else setLoading(false);
  };

  useEffect(() => {
    getTeamByProjectId('');
  }, [getTeamByProjectId]);

  const handleModalSubmit = async () => {
    dispatch(setFetchProjectsInProgress());
    const payload: any = await fetchProjects('');
    dispatch(saveProjects(payload.data || []));
    navigate(`/project/${projectId}`, { replace: true });
  };

  return (
    <>
      <div className="launch-step d-flex flex-column h-100">
        <div className="step-wrapper flex-grow-1">
          <Row>
            {steps.slice(0, 5).map((step: string, index: number) => (
              <Col sm="12" key={step}>
                <Link
                  to={`/project/setup/${projectId}/${index + 1}`}
                  className="text-decoration-none text-body"
                >
                  <div className="border-bottom py-3 d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <p className="mb-0">{step}</p>
                    </div>
                    {(data?.length === 0 && index === 1) ||
                    (projectDetails.checklists?.length === 0 && index === 2) ||
                    (projectDetails.tasks?.length === 0 && index === 3) ||
                    (projectDetails.documents?.length === 0 && index === 4) ? (
                      <span className="bg-danger icon mr-3 rounded-circle d-flex align-items-center justify-content-center text-white">
                        <CancelIcon width="16" height="16" />
                      </span>
                    ) : (
                      <span className="bg-success icon mr-3 rounded-circle d-flex align-items-center justify-content-center text-white">
                        <CheckIcon width="16" height="16" />
                      </span>
                    )}
                  </div>
                </Link>
              </Col>
            ))}
          </Row>
        </div>
        <div className="d-flex justify-space-between">
          <Button
            variant="outline-primary"
            onClick={() => {
              navigate({
                pathname: `/project/setup/${projectId}/${Number(step) - 1}`,
              });
            }}
          >
            {t('btn_back')}
          </Button>
          <Button
            variant="primary"
            className="ms-auto"
            onClick={saveProject}
            disabled={loading}
          >
            {t('btn_launch')}
          </Button>
        </div>
      </div>
      <Modal
        show={show}
        title={t('successfull')}
        type="success"
        modalClassName="project-modal"
        withIcon={true}
        onClose={handleClose}
        submitBtnText={t('modal_btn_back_to_projects')}
        onSubmit={handleModalSubmit}
        withIconBodyText={t('modal_body_project_setup')}
        footerContentAlignment="center"
        hideCancelBtn
      />
    </>
  );
};

export default Launch;
